(function () {
  function initScroller(root) {
    if (root.dataset.ogtLpMcScrollerInit === 'true') return;
    root.dataset.ogtLpMcScrollerInit = 'true';

    var track =
      root.querySelector('[data-ogt-lp-mc-scroll-viewport]') ||
      root.querySelector('[data-ogt-lp-mc-scroll-track]');
    if (!track) return;

    var prev = root.querySelector('[data-ogt-lp-mc-scroll-prev]');
    var next = root.querySelector('[data-ogt-lp-mc-scroll-next]');
    var gap = parseInt(root.dataset.scrollGap || '0', 10) || 0;

    function getStep() {
      var item = track.querySelector('.ogt-lp-column, .shopify-block');
      if (!item) return Math.max(track.clientWidth, 120);
      return item.getBoundingClientRect().width + gap;
    }

    function updateButtons() {
      if (!prev || !next) return;
      var maxScroll = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll - 2;
    }

    function scrollByDir(dir) {
      track.scrollBy({ left: dir * getStep(), behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { scrollByDir(-1); });
    if (next) next.addEventListener('click', function () { scrollByDir(1); });
    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  }

  function boot() {
    document.querySelectorAll('[data-ogt-lp-mc-scroller]').forEach(initScroller);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', boot);
})();
